import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const BentoCard = ({ service, index, wide = false }) => {
  const num = String(index + 1).padStart(2, "0");
  return (
    <Link
      to={`/services/${service.slug}`}
      data-testid={`service-card-${service.slug}`}
      onMouseMove={(e) => {
        const r = e.currentTarget.getBoundingClientRect();
        e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
        e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
      }}
      className={`spotlight group relative flex min-h-[320px] flex-col justify-between overflow-hidden rounded-3xl border border-slate-200 bg-white p-8 transition-[transform,box-shadow] duration-500 hover:-translate-y-1 hover:shadow-[0_36px_70px_-32px_rgba(15,23,42,0.3)] md:p-10 ${
        wide ? "md:col-span-7" : "md:col-span-5"
      }`}
    >
      {service.image && (
        <div className="absolute inset-y-0 right-0 hidden w-[45%] overflow-hidden rounded-l-[1.6rem] md:block">
          <img
            src={service.image}
            alt=""
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-white via-white/25 to-transparent" />
        </div>
      )}
      <div className={`relative z-[2] max-w-[62%] ${service.image ? "" : "max-w-full"}`}>
        <span className="font-mono text-xs tracking-[0.2em] text-primary">{num}</span>
        <h3 className="mt-5 font-display text-2xl font-semibold leading-tight tracking-tight text-ink md:text-[1.7rem]">
          {service.title}
        </h3>
        <p className="mt-3 text-[15px] leading-relaxed text-soot">{service.tagline}</p>
      </div>
      <div className="relative z-[2] mt-8 flex items-center justify-between">
        <span className="inline-flex items-center gap-2 font-display text-[15px] font-semibold text-primary">
          Explore service
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </span>
        <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-300">
          TecKube
        </span>
      </div>
    </Link>
  );
};

export default BentoCard;
